import departureCity from '@/js/common/Domain/Hydrator/toRouter/departureCity';
import resorts from '@/js/common/Domain/Hydrator/toRouter/resorts';
import checkInDateRange from '@/js/common/Domain/Hydrator/toRouter/checkInDateRange';
import nightRange from '@/js/common/Domain/Hydrator/toRouter/nightRange';
import touristGroup from '@/js/common/Domain/Hydrator/toRouter/touristGroup';
import hotelCategories from '@/js/common/Domain/Hydrator/toRouter/hotelCategories';
import meals from '@/js/common/Domain/Hydrator/toRouter/meals';
import directFlights from '@/js/common/Domain/Hydrator/toRouter/directFlights';
import block from '@/js/common/Domain/Hydrator/toRouter/block';
import warranted from '@/js/common/Domain/Hydrator/toRouter/warranted';
import isExclusive from '@/js/common/Domain/Hydrator/toRouter/isExclusive';

export default (tourCriteria, otherCriteria) => ({
    ...departureCity(tourCriteria),
    ...resorts(tourCriteria),
    ...checkInDateRange(tourCriteria),
    ...nightRange(tourCriteria),
    ...touristGroup(tourCriteria),
    ...hotelCategories(tourCriteria),
    ...meals(tourCriteria),
    ...directFlights(tourCriteria),
    ...block(tourCriteria),
    ...warranted(tourCriteria),
    ...isExclusive(tourCriteria),
    ...otherCriteria,
});